import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Profile from "./Profile";
import BusinessProfile from "./BusinessProfile/BusinessProfile";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== "undefined" &&
  window.location.hostname.includes("onrender.com")
    ? "https://cvanto-api.onrender.com"
    : "http://localhost:5000");

export default function ProfileRouter() {
  const params = useParams();
  const { userId } = useAuth();

  const viewedUserId = useMemo(() => {
    return params.userId || params.id || userId || "";
  }, [params.userId, params.id, userId]);

  const [loading, setLoading] = useState(true);
  const [isBusiness, setIsBusiness] = useState(false);

  useEffect(() => {
    let alive = true;

    async function checkPlan() {
      if (!viewedUserId) {
        setLoading(false);
        setIsBusiness(false);
        return;
      }

      try {
        setLoading(true);
        setIsBusiness(false);

        const res = await fetch(
          `${API_BASE}/api/account/${encodeURIComponent(viewedUserId)}`,
          {
            cache: "no-store",
          }
        );

        if (!alive) return;

        if (!res.ok) {
          setIsBusiness(false);
          return;
        }

        const data = await res.json().catch(() => ({}));

        const activePlan =
          data?.subscription?.plan ||
          data?.plan ||
          "free";

        const businessActive =
          activePlan === "business" &&
          data?.subscription?.isBusiness === true;

        setIsBusiness(businessActive);
      } catch (error) {
        if (!alive) return;

        console.error(
          "[ProfileRouter] Не вдалося перевірити тариф:",
          error
        );

        setIsBusiness(false);
      } finally {
        if (alive) {
          setLoading(false);
        }
      }
    }

    checkPlan();

    return () => {
      alive = false;
    };
  }, [viewedUserId]);

  if (loading) {
    return null;
  }

  return isBusiness ? (
    <BusinessProfile />
  ) : (
    <Profile />
  );
}